import React, {
    useContext, useEffect, useRef, useState,
} from "react";
import Link from "helpers/link";
import useDebounce from "hooks/useDebounce";
import { PatioContext } from "@root/context/patio-calculator";
import InputField from "../../_components/input-field";

export const MeasureInput = ({ data, updateConfiguration, className }) => {
    const { activeCoordinate, setActiveCoordinate, configuration } = useContext(PatioContext) || {};
    const { key, name, value, default: defaultValue, minimum } = data;
    const [quantity, setQuantity] = useState(configuration[key] || defaultValue || value);
    const debounceRender = useDebounce(quantity, 300);
    const inputRef = useRef(null);

    useEffect(() => {
        updateConfiguration({ [key]: +quantity });
    }, [debounceRender]);

    const handleChange = (event) => {
        const inputValue = +event.target.value === 0 ? "" : +event.target.value;
        setQuantity(inputValue);
    };

    const indexToLetter = (index) => String.fromCharCode(65 + index);

    // focus field when activeCoordinate is equal to the key
    useEffect(() => {
        if (activeCoordinate === key) {
            // find the input field in ref and focus it
            inputRef.current.querySelector("input").focus();
        }
    }, [activeCoordinate]);

    return (
        <div ref={inputRef} className={`${className} configurator-section__inner-fields-field ${activeCoordinate === key ? "configurator-section__inner-fields-field--active" : ""}`}>
            <InputField
                className={`configurator-measure`}
                value={quantity}
                suffix="Inches"
                onChange={handleChange}
                marker={indexToLetter(data.index)}
                label={name}
                type="number"
                min={minimum || 1}
                max={10000}
                onFocus={() => setActiveCoordinate(key)}
                onBlur={() => setActiveCoordinate(null)}
            />

            <p className={`base-input__error base-input__label base-input__minimum`}>
                {minimum && (
                    <>
                        Min:
                        {" "}
                        {minimum}
                        ″
                    </>
                )}
            </p>

        </div>
    );
};

const Measurement = ({ file, measurements, updateConfiguration }) => {
    const [showPopup, setShowPopup] = useState(false);

    return (
        <div className="configurator-section">
            <div className="configurator-section__header">
                <h3 className="configurator-section__header-title">1. Measurement</h3>
                {file && (<Link to={file} target="_blank" className="configurator-section__header-link">(How to measure?)</Link>)}
            </div>

            <div className="configurator-section__inner">
                <div className="configurator-section__inner-fields">
                    {measurements?.map((measurement, index) => (
                        <MeasureInput
                            data={{
                                ...measurement,
                                index,
                            }}
                            key={measurement?.key}
                            updateConfiguration={updateConfiguration}
                            className={measurement?.minimum || measurements[index + (index % 2 === 0 ? 1 : -1)]?.minimum ? 'row-has-minimum' : ''}
                        />
                    ))}
                </div>
                <div className="configurator-section__inner-hints">
                    <div className="flex">
                        <h5 className="configurator-section__inner-extra" onFocus={() => setShowPopup(true)} onMouseOver={() => setShowPopup(true)} onMouseLeave={() => setShowPopup(false)}>Extra 1-2&quot; Leeway</h5>
                        <div className="relative ml-1">
                            <div className={`configurator-section__inner-popup dynamic-arrow absolute w-64 py-1.5 px-4 bg-white left-[125%] -top-[35%] rounded-2xl leading-6 shadow-popup ${showPopup ? "block" : "hidden"}`}>
                                We add 1&quot; to 2&quot; leeway on the given width/depth, for an easy pull-in, pull-out
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Measurement;
